import TheProduct from '@elem/compPage/riverpro-firmware-update-guide';
import { IPageStatus } from '@elem/compPage/riverpro-firmware-update-guide/config/IPageStatus';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import gtm from 'eco-design-reliance/gtm';
import { useEffect } from 'react';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { redirectTo404 } from '@/utils';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';

const whiteLocaleList = ['jp'];
export default function Page({ SEO, lang }: any) {
    const { locale = 'jp' } = useRouter();
    const { t } = useLang('theProduct');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    const startHandle = () => {
        console.log('触发');
        gtm.push({
            event: 'uaEvent',
            event_name: 'view_firmware_upgrade',
            list_name: t('title'),
        });
    };

    useEffect(() => {
        const initHandle = () => {
            EcoDesignEventsBus.on('GtmPageLoad-start', () => {
                startHandle();
            });
        };
        initHandle();
    }, []);

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={lang.seo_title || t('seo_title')} description={lang.seo_desc || t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="riverpro-firmware-update-guide" />
            <GtmPageLoad />
            <TheProduct />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/riverpro-firmware-update-guide/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/riverpro-firmware-update-guide/config/times/jp.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    // 时间节点判断 正式环境未开始重定向404
    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }
    // 当前阶段
    let pageStatus = IPageStatus.statusA;
    if (timeLine) {
        if (systemTime >= timeLine?.statusC?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            // 系统时间进入 statusB 时间段
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        } else {
            return redirectTo404();
        }
    }

    return {
        props: {
            systemTime,
            timeLine: timeLine,
            debug: debug || '',
            pageStatus: pageStatus,
        },
    };
}
